import { pastelTheme } from 'notivue';

// https://docs.notivue.smastrom.io/built-in-notifications/styling

// Check the variable names in:
// Repo: https://github.com/smastrom/notivue.git
// File: /packages/notivue/Notifications/notifications.css
const toastTheme = {
  ...pastelTheme,
  '--nv-promise-border': '#b4a0ff',
  '--nv-info-border': '#409ae1',
  '--nv-success-border': '#40c5af',
  '--nv-warning-border': '#f38701',
  '--nv-error-border': '#c41e3a',
  '--nv-border-width': '1px',
};
export default toastTheme;
